import cs from "classnames";
import React from "react";

import "./Card.css";

interface CardProps {
	className?: string;
}

export const Card: React.FunctionComponent<
	React.PropsWithChildren<CardProps>
> = ({ className, children }) => (
	<div className={cs("card", className)}>{children}</div>
);

export const CardHeader: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="card__header">{children}</div>;

export const CardTitle: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="card__title">{children}</div>;

export const CardActions: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="card__actions">{children}</div>;

export const CardContent: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="card__content">{children}</div>;

export const CardMessage: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="card__message">{children}</div>;

export const CardFooter: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="card__footer">{children}</div>;
